const REFRESH_KEY = 'portfoli.refresh';

export interface StoredTokens {
  readonly accessToken: string;
  readonly refreshToken: string;
  readonly expiresAt: string;
}

type Listener = (tokens: StoredTokens | null) => void;

let memory: StoredTokens | null = null;
const listeners = new Set<Listener>();

function readRefreshFromStorage(): string | null {
  try {
    return window.localStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

function writeRefreshToStorage(token: string | null): void {
  try {
    if (token === null) window.localStorage.removeItem(REFRESH_KEY);
    else window.localStorage.setItem(REFRESH_KEY, token);
  } catch {
    // storage unavailable — refresh simply won't persist across tabs/reloads
  }
}

export const tokenStore = {
  get(): StoredTokens | null {
    return memory;
  },

  getAccessToken(): string | null {
    return memory?.accessToken ?? null;
  },

  getRefreshToken(): string | null {
    return memory?.refreshToken ?? readRefreshFromStorage();
  },

  set(tokens: StoredTokens): void {
    memory = tokens;
    writeRefreshToStorage(tokens.refreshToken);
    for (const l of listeners) l(tokens);
  },

  clear(): void {
    memory = null;
    writeRefreshToStorage(null);
    for (const l of listeners) l(null);
  },

  hasRefresh(): boolean {
    return Boolean(memory?.refreshToken ?? readRefreshFromStorage());
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
